module.exports = __webpack_public_path__ + "media/images/check-879f43dd18637678dd0a2f986b6accc4.png";